import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import DataFunction from "../../../Functions/AllFunctions";
import ProductCategoryServices from "../../../services/ProductCategoryServices";
import UploadServices from "../../../services/UploadServices";
import TableLoader from "../../../Reuseable/TableLoader";

const ProductCategories = () => {
  const [allCategories, setAllCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  // Form State
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const getData = useCallback(() => {
    ProductCategoryServices.getAllProductsCategory()
      .then((res) => {
        setAllCategories(res);
      })
      .catch((err) => console.log(err.message));
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  const addImage = () => {
    var formdata = new FormData();
    formdata.append("file", imageName);
    UploadServices.UploadSingle(formdata)
      .then((res) => {
        console.log("Image Uploaded");
        getData();
      })
      .catch((err) => {
        console.log(err.message);
        getData();
      });
  };

  const createCategory = (e) => {
    e.preventDefault();
    const body = {
      title: title,
      meta_title: metaTitle,
      description: description,
      meta_description: metaDescription,
      image: imageName?.name,
    };
    ProductCategoryServices.createProductsCategory(body)
      .then((res) => {
        addImage();
        setTitle("");
        setMetaTitle("");
        setDescription("");
        setMetaDescription("");
        setImage(null);
      })
      .catch((error) => console.log(error.message));
  };

  const deleteCategory = (e, id) => {
    e.preventDefault();
    ProductCategoryServices.deleteProductsCategory(id)
      .then((res) => {
        getData();
      })
      .catch((err) => {
        console.log(err.message);
        getData();
      });
  };

  const editCategory = (e, id) => {
    e.preventDefault();
    console.log("hello");
    const body = {
      title: title,
      meta_title: metaTitle,
      description: description,
      meta_description: metaDescription,
      image: imageName?.name,
    };
    ProductCategoryServices.updateProductsCategory(id, body)
      .then((res) => {
        addImage(null);
        setTitle("");
        setDescription("");
        setImage(null);
        setMetaTitle("");
        setMetaDescription("");
        setIsEditing(false);
        setEditId(null);
      })
      .catch((error) => console.log(error.message));
  };

  const handelEditClick = (e, item) => {
    setIsEditing(true);
    setEditId(item?._id);
    setTitle(item?.title);
    setMetaTitle(item?.meta_title);
    setDescription(item?.description);
    setMetaDescription(item?.meta_description);
    setImageName(item?.image);
    console.log("item?.image", item?.image);
  };

  return (
    <>
      <Helmet>
        <title>Product Categories - Emberace</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Products Categories</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Products</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <div className="card">
                  <div className="card-body">
                    <form
                      onSubmit={
                        isEditing
                          ? (e) => editCategory(e, editId)
                          : (e) => createCategory(e)
                      }
                    >
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Title
                        </label>
                        <div className="col-md-12">
                          <input
                            required
                            className="form-control"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Description
                        </label>
                        <div className="col-md-12">
                          <textarea
                            rows={3}
                            required
                            className="form-control"
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Image
                        </label>
                        <div className="col-md-12">
                          <input
                            className="form-control"
                            type="file"
                            onChange={(e) => setImageName(e.target.files[0])}
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Meta Title
                        </label>
                        <div className="col-md-12">
                          <input
                            required
                            className="form-control"
                            type="text"
                            value={metaTitle}
                            onChange={(e) => setMetaTitle(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className="col-md-12 col-form-label"
                        >
                          Meta Description
                        </label>
                        <div className="col-md-12">
                          <textarea
                            required
                            rows={3}
                            className="form-control"
                            type="text"
                            value={metaDescription}
                            onChange={(e) => setMetaDescription(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          style={{ width: "100%" }}
                        >
                          Submit form
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-8">
                <div className="card">
                  <div className="card-body">
                    {allCategories.length === null ||
                    allCategories.length === 0 ? (
                      <TableLoader />
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Image</th>
                              <th>Title</th>
                              <th>Actions</th>
                            </tr>
                          </thead>

                          <tbody>
                            {allCategories &&
                              allCategories?.map((el, index) => (
                                <tr key={index}>
                                  <th scope="row">{++index}</th>
                                  <td>{DataFunction.imageCheck(el?.image)}</td>
                                  <td>{el?.title}</td>
                                  <td>
                                    <i
                                      className="mdi mdi-trash-can-outline iconsize"
                                      onClick={(e) => deleteCategory(e, el._id)}
                                    />
                                    <i
                                      className="mdi mdi-pencil-box-outline iconsize"
                                      onClick={(e) => handelEditClick(e, el)}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCategories;
